export default __webpack_public_path__ + "static/media/credit-card-icon.082c6c6f.svg";